module.exports = __webpack_public_path__ + "static/img/yingrenClick.9b88e10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/yingrenClick.png
// module id = JW/H
// module chunks = 0